export function setComments(state, payload) {
  state.comments = payload;
}

export function setTotalComments(state, payload) {
  state.totalComments = payload;
}

export function setCommentsSeeMore(state, payload) {
  let comments = [...state.comments, ...payload]
  state.comments = comments
}

export function setLoading(state, payload) {
  state.loading = payload;
}